/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import rrulePlugin from '@fullcalendar/rrule'
import timeGridPlugin from '@fullcalendar/timegrid'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Dropdown, Modal, ModalBody } from 'reactstrap'

import { ROUTE_TYPE } from '../../../../Configuration'
import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import { getRecurringEventData, scrollToTop } from '../../../../assets/ts/general/general'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import useCalendar from '../../../../hooks/use-calendar'
import { SettingsHeader } from '../../../../layouts/header/settings-header'
import {
  MetadataContext,
  MetadataContextInterface,
} from '../../../../store/metadata-context-provider'
import { PreviousPageContext } from '../../../../store/previous-page-provider'
import { UserContext } from '../../../../store/user-context-provider'
import {
  ALL_SELECT_LABEL,
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  ALL_SELECT_VALUE,
} from '../../../../utils/constants/global-constants'
import { DELETE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import CustomSelect from '../../../../utils/controls/custom-select'
import {
  optionsTypes,
} from '../../../../utils/controls/select-options-data'
//import Modal, {ModalProps} from '../../'
import AddEventForm from './AddEvent/add-event-form'
import './calendar.css'

interface CalendarEvent {
  EndDate: string
  EventDate: string
  FreeBusy: string
  Id: number
  Title: string
  rrule: any
}
const SettingsCalendar = ({
  assignedComponentOptions,
  initialMajcomOptions,
  initialSectionOptions,
  roleContext,
  visibleSquadrons,
}: any) => {
  //usePageTitle(PAGE_TITLE.CALENDAR)
  const navigate = useNavigate()
  const { setPreviousPage } = useContext(PreviousPageContext)
  const { userProfile } = useContext(UserContext)

  const currUser = userProfile[0]

  const { sections, } = useContext(MetadataContext)

  const [sectionOptions, setSectionOptions] = useState<any[]>(initialMajcomOptions)
  const [majcomOptions, setMajcomOptions] = useState<any[]>(initialSectionOptions)

  const metadataContext = useContext(MetadataContext)
  const [calendarEvents, setCalendarEvents] = useState<CalendarEvent[]>([])
  const [categoriesOptions, setCategoriesOptions] = useState<Array<Dropdown>>([])
  const [showEventDetails, setShowEventDetails] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState<CalendarEvent | null>(null)
  const [inputValues, setInputValues]: any = useState({
    AssignedComponent: '',
    AssignedComponentCode: -1,
    Category: '',
    CategoryCode: -1,
    Section: '',
    SectionCode: '',
    ServicingMAJCOM: '',
    ServicingMAJCOMCode: -1,
  })
  const [showAlert, setShowAlert] = useState(false)
  const [showEventForm, setShowEventForm] = useState(false)
  const [editEvent, setEditEvent] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [eventRRule, setEventRRule] = useState()
  const isInitialLoad = useRef(true)

  const fetchEvents = async () => {
    try {
      // Format the events from CalendarData
      const formattedEvents: CalendarEvent[] = await CalendarData.map((event) => {
        const RRules = event?.RRule ? JSON.parse(event?.RRule) : undefined
        const recurringEvents: any[] = getRecurringEventData(RRules, event, metadataContext)

        if (recurringEvents && recurringEvents.length > 0) {
          return recurringEvents
        } else {
          return {
            allDay: event.IsAllDayEvent,
            daysOfWeek: RRules?.daysOfWeek ? RRules.daysOfWeek : undefined,
            description: event.Description,
            end: event.EndDate,
            endRecur: RRules?.until ? RRules?.until : undefined,
            etag: event.eTag,
            eventRRule: event.RRule,
            extendedProps: {
              AssignedComponent: event.AssignedComponentCode,
              Category: event.Category,
              IsAllDayEvent: event.IsAllDayEvent,
              IsArchived: event.IsArchived,
              Location: event.Location,
              MAJCOM:
                metadataContext?.majcomOptions.find((option) => 
                  option.value === event?.MAJCOMCode
              )
                  ?.label || 'Unknown',
              MAJCOMCode: event.MAJCOMCode,
              Section:
                metadataContext?.sectionOptions.find((option) => 
                  option.value === event?.SectionCode
              )
                  ?.label || 'Unknown',
              SectionCode: event.SectionCode,
              ServicingOrganization: event.ServicingOrganization,
            },
            id: event.eKey,
            rRule: RRules,
            start: event.StartDate,
            startRecur: RRules?.dtstart ? RRules?.dtstart : undefined,
            title: event.Title,
          }
        }
      })
      // Batch state updates to minimize re-renders
      setCalendarEvents((prevEvents) => {

        if (JSON.stringify(prevEvents) !== JSON.stringify(formattedEvents)) {
          return formattedEvents.flat()
        }
        return prevEvents
      })

      // Check if there are unique categories to update
      if (CalendarData.length > 0) {
        const uniqueCategorySet = new Set([
          ...categoriesOptions, // existing categories
          ...CalendarData.map((data) => data.Category), // new categories
        ])

        const uniqueCategories = Array.from(uniqueCategorySet)

        if (uniqueCategories.length !== categoriesOptions.length) {
          setCategoriesOptions(uniqueCategories)
        }
      }
    } catch (error) {
      console.error('Error fetching events:', error)
    }
  }

  const updateInputValuesFromProfile = () => {
    if (userProfile && userProfile.length > 0) {
      const assignedComponentValue = currUser?.['AssignedComponent/MetadataValue'] || ''
      const assignedComponentCode = currUser?.AssignedComponentCode || ''
      const servicingMajcom = roleContext.isCPOwner ? '' : currUser?.ServicingMAJCOM || ''

      setInputValues({
        AssignedComponent: assignedComponentValue,
        AssignedComponentCode: assignedComponentCode,
        ServicingMAJCOM: servicingMajcom,
        ServicingMAJCOMCode:
          majcomOptions?.find((option) => option.label === servicingMajcom)?.label || -1,
      })

      fetchCalendarData()
    }
  }

  useEffect(() => {
    setMajcomOptions(initialMajcomOptions)
    setSectionOptions(initialSectionOptions)
  }, [initialMajcomOptions, initialSectionOptions])

  useEffect(() => {
    updateInputValuesFromProfile()
  }, [userProfile])

  const { CalendarData, CalendarDataIsLoading, fetchCalendarData } = useCalendar({
    assignedComponentFilter: inputValues?.AssignedComponentCode,
    categoryFilter: inputValues?.Category,
    isArchived: false,
    sectionFilter: inputValues?.SectionCode,
    servicingMajcomFilter: inputValues?.ServicingMAJCOMCode,
  })

  const calendarEl = useRef<HTMLDivElement | null>(null)

  const redirectToHome = () => {
    navigate(`${ROUTE_TYPE}`)
  }

  useEffect(() => {
    fetchEvents()
  }, [CalendarData])

  const selectEvent = (info: any) => {
    const event = calendarEvents.find((i) => i.id === info.event?.id)
    setSelectedEvent(event || null)
    setShowEventDetails(true)
    setIsEdit(true)
    setEditEvent(event)
    setShowEventForm(true)
    setEventRRule(event?.eventRRule)
  }

  useEffect(() => {
    if (calendarEl.current) {
      const calendar = new Calendar(calendarEl.current, {
        dayMaxEvents: true,
        eventClick: selectEvent,
        eventContent: function (info) {
          const title = info.event.title
          const timeText = info.timeText.replace('a', 'AM').replace('p', 'PM')
          return {
            html: `<div title="${title}"><b>${timeText}</b><span> ${title}</span></div>`,
          }
        },
        events: calendarEvents,
        headerToolbar: {
          center: 'title',
          left: 'prev,next today',
          right: 'dayGridMonth,timeGridWeek,timeGridDay',
        },
        initialView: 'dayGridMonth',
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, rrulePlugin],
      })

      calendar.render()
    }
  }, [calendarEvents])

  useEffect(() => {
    let majcomValue = ALL_SELECT_OPTION.value
    let majcomLabel = ALL_SELECT_OPTION.label
    let assigneComponentValue = ALL_SELECT_OPTION.value
    let assignedComponentLabel = ALL_SELECT_OPTION.label
    let sectionLabel = ALL_SELECT_OPTION.label
    let sectionValue = ALL_SELECT_OPTION.value

    if (initialMajcomOptions.length === 1) {
      majcomValue = initialMajcomOptions[0].value
      majcomLabel = initialMajcomOptions[0].label
    }

    if (assignedComponentOptions.length === 1) {
      assigneComponentValue = assignedComponentOptions[0].value
      assignedComponentLabel = assignedComponentOptions[0].label
    }

    if (initialSectionOptions.length === 1) {
      sectionValue = initialSectionOptions[0].value
      sectionLabel = initialSectionOptions[0].label
    }

    setInputValues((prevState) => ({
      ...prevState,
      AssignedComponent: assignedComponentLabel,
      AssignedComponentCode: assigneComponentValue,
      Section: sectionLabel,
      SectionCode: sectionValue,
      ServicingMAJCOM: majcomLabel,
      ServicingMAJCOMCode: majcomValue,
      assignComponent: assigneComponentValue,
      majcom: majcomLabel,
      majcomCode: majcomValue,
      section: sectionLabel,
      sectionCode: sectionValue,
    }))
  }, [assignedComponentOptions, initialMajcomOptions, initialSectionOptions])

  const onAssignedComponentChange = (e) => {
    const majOptions: any[] = initialMajcomOptions
      .filter((item) => item.assignedComponentCode === e.value || e.value === -1)
      .map((majcom) => ({
        assignedComponentCode: majcom.assignedComponentCode,
        label: majcom.label,
        squadron: majcom.squadron,
        value: majcom.value,
      }))

    const sectOptions: optionsTypes[] = sections
      .filter((section) => {
        let containsSquadron = false

        Object.keys(visibleSquadrons).forEach((key) => {
          if (visibleSquadrons[key].length > 0) {
            const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

            if (key === 'SectionChief' || key === 'SectionOwner') {
              if (
                visibleSquadrons[key].some(
                  (e) =>
                    e.section === formattedSection &&
                    majOptions.some((maj) => maj.squadron === e.squadron)
                )
              ) {
                containsSquadron = true
              }
            }
          }
        })

        return (
          containsSquadron ||
          roleContext?.isCPOwner ||
          roleContext?.isMAJCOMOwner ||
          roleContext?.isAssignedComponentOwner
        )
      })
      .map((section) => {
        const filteredSectOpt = initialSectionOptions.filter(
          (sect) => sect.value === section?.SectionCode
        )[0]

        return {
          label: section?.Section,
          majcom: filteredSectOpt.majcom,
          squadron: filteredSectOpt.squadron,
          value: section?.SectionCode,
        }
      })

    if (majOptions.length > 1 && majOptions[0].value !== -1) {
      majOptions.unshift(ALL_SELECT_OPTION)
    }

    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    }

    setMajcomOptions(majOptions)
    setSectionOptions(sectOptions)
    setInputValues((prev) => ({
      ...prev,
      AssignedComponent: e.label,
      AssignedComponentCode: e.value,
      Section: sectOptions.length === 1 ? sectOptions[0].label : ALL_SELECT_LABEL,
      SectionCode: sectOptions.length === 1 ? sectOptions[0].value : ALL_SELECT_VALUE,
      ServicingMAJCOM: majOptions.length === 1 ? majOptions[0].label : ALL_SELECT_LABEL,
      ServicingMAJCOMCode: majOptions.length === 1 ? majOptions[0].value : ALL_SELECT_VALUE,
    }))
  }

  const onMajcomChange = (e) => {
    const sectOptions: any[] = sections
      .filter((section) => {
        let containsSquadron = false

        Object.keys(visibleSquadrons).forEach((key) => {
          if (visibleSquadrons[key].length > 0) {
            const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

            if (key === 'SectionChief' || key === 'SectionOwner') {
              if (
                visibleSquadrons[key].some(
                  (sect) =>
                    sect.section === formattedSection &&
                    (sect.squadron === e.squadron || e.value === -1)
                )
              ) {
                containsSquadron = true
              }
            }
          }
        })

        return (
          containsSquadron ||
          roleContext?.isCPOwner ||
          roleContext?.isMAJCOMOwner ||
          roleContext?.isAssignedComponentOwner
        )
      })
      .map((section) => {
        const filteredSectOpt = initialSectionOptions.filter(
          (sect) => sect.value === section?.SectionCode
        )[0]

        return {
          label: section?.Section,
          majcom: filteredSectOpt.majcom,
          squadron: filteredSectOpt.squadron,
          value: section?.SectionCode,
        }
      })

    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    }

    setSectionOptions(sectOptions)

    setInputValues((prevState) => ({
      ...prevState,
      Section: sectOptions.length === 1 ? sectOptions[0].label : ALL_SELECT_LABEL,
      SectionCode: sectOptions.length === 1 ? sectOptions[0].value : ALL_SELECT_VALUE,
      ServicingMAJCOM: e.label,
      ServicingMAJCOMCode: e.value,
    }))
  }

  const onSectionChange = (e) => {
    setInputValues((prevState) => ({
      ...prevState,
      Section: e.label,
      SectionCode: e.value,
    }))
  }

  function onClear() {
    updateInputValuesFromProfile()
    setMajcomOptions([])

    setInputValues((prev) => ({
      ...prev,
      AssignedComponent: ALL_SELECT_LABEL,
      AssignedComponentCode: ALL_SELECT_VALUE,
      Category: ALL_SELECT_LABEL,
      SectionCode: ALL_SELECT_VALUE,
      ServicingMAJCOM: ALL_SELECT_LABEL,
      ServicingMAJCOMCode: ALL_SELECT_VALUE,
    }))
  }

  useEffect(() => {
    scrollToTop()
    setPreviousPage('calendar')
  }, [])
  function removeDuplicates(arr, key) {
    const seen = new Set()
    return arr.filter((item) => {
      const keyValue = item[key]
      if (seen.has(keyValue)) {
        return false
      } else {
        seen.add(keyValue)
        return true
      }
    })
  }

  const findUserAssignedComponent = (sevOrg: number[], metadata: MetadataContextInterface) => {
    const assComp = sevOrg.map((org) => {
      const componentCode = metadata.pascodeMetadata.find(
        (e) => e.AssignedComponentCode === org
      )?.AssignedComponentCode

      const componentName = metadata.components
        .filter((e) => e.ComponentCode === componentCode)
        .map((a) => a.Component)

      return { label: componentName[0], value: componentCode }
    })
    return removeDuplicates(assComp, 'value')
  }
  const findUserAssignedComponentWithOrg = (
    sevOrg: string[],
    metadata: MetadataContextInterface
  ) => {
    const assComp = sevOrg.map((org) => {
      const componentCode = metadata.pascodeMetadata.find(
        (e) => e.ServicingOrganization === org
      )?.AssignedComponentCode
      const componentName = metadata.components
        .filter((e) => e.ComponentCode === componentCode)
        .map((a) => a.Component)

      return { label: componentName[0], value: componentCode }
    })
    return removeDuplicates(assComp, 'value')
  }
  const findUserAssignedComponentWithMAJ = (
    majcom: number[],
    metadata: MetadataContextInterface
  ) => {
    const assComp = majcom.map((maj) => {
      const componentCode = metadata.majcoms.find((e) => e.Value === maj)?.ParentComponentCode
      const componentName = metadata.components
        .filter((e) => e.ComponentCode === componentCode)
        .map((a) => a.Component)
      return { label: componentName[0], value: componentCode }
    })
    return removeDuplicates(assComp, 'value')
  }
  const findMAJCOM = (sevOrg: number[] | string[], metadata: MetadataContextInterface) => {
    if (typeof sevOrg[0] === 'string') {
      const servicingMAJCOM = sevOrg.map((org) => {
        return metadata.pascodeMetadata.find((e) => e.ServicingOrganization === org)
          ?.ServicingMAJCOM
      })
      const majcoms = metadata.majcoms
        .filter((majcom) => majcom.MAJCOM === servicingMAJCOM[0])
        .map((e) => ({ label: e.Label, value: e.MAJCOMCode }))
      return majcoms
    } else {
      const majcomOptions = metadata.majcoms
        .filter((majcom) => majcom.ParentComponentCode === sevOrg[0])
        .map((e) => ({ label: e.Label, value: e.MAJCOMCode }))
      return [...[ALL_SELECT_OPTION], ...majcomOptions]
    }
  }
  const findMAJCOMWithMAJCOMCode = (majCode: number[], metadata: MetadataContextInterface) => {
    const majcomOption = metadata.majcoms
      .filter((majcom) => majcom.MAJCOMCode === majCode[0])
      .map((e) => ({ label: e.Label, value: e.MAJCOMCode }))
    return majcomOption
  }

  const findUserSection = (sec: number[], metadata: MetadataContextInterface) => {
    const section = sec.map((org) => {
      const sectionName = metadata.sections
        .filter((e) => e.SectionCode === org)
        .map((a) => a.Section)

      return { label: sectionName[0], value: org }
    })

    return section
  }

  let userAssignComponent
  let userMAJCOM
  let userServicingOrganization
  let userSections
  const filter = roleContext.initialInquiryAndDueoutFilter
  if (
    filter.assignedComponentCodeFilter?.length === 0 &&
    filter.majcomCodeFilter?.length === 0 &&
    filter.servicingOrganizationFilter?.length === 0 &&
    filter.servicingOrganizationWithoutSectionFilter?.length === 0
  ) {
    // Run this block for CP Owners
    userAssignComponent = [
      ...[ALL_SELECT_OPTION],
      ...(metadataContext.components ?? []).map(({ Label, Value }) => ({
        label: Label,
        value: Value,
      })),
    ]
    userMAJCOM = []
    userServicingOrganization = [ALL_SELECT_OPTION_STRING]
  } else if (
    filter.assignedComponentCodeFilter?.length === 0 &&
    filter.majcomCodeFilter?.length > 0
  ) {
    // Runs for MAJCOM Owners
    userAssignComponent = findUserAssignedComponentWithMAJ(filter.majcomCodeFilter, metadataContext)
    userServicingOrganization = [ALL_SELECT_OPTION_STRING]
  } else if (
    filter.assignedComponentCodeFilter?.length > 0 &&
    filter.majcomCodeFilter?.length > 0
  ) {
    // Runs for AFRC and ANG Owners
    userAssignComponent = findUserAssignedComponent(
      filter.assignedComponentCodeFilter,
      metadataContext
    )
    userServicingOrganization = [ALL_SELECT_OPTION_STRING]
  } else if (
    filter.assignedComponentCodeFilter?.length > 0 &&
    filter.majcomCodeFilter?.length === 0
  ) {
    // Runs for RegAF Owners
    userAssignComponent = findUserAssignedComponent(
      filter.assignedComponentCodeFilter,
      metadataContext
    )
    userMAJCOM = []
    userServicingOrganization = [ALL_SELECT_OPTION_STRING]
  } else if (filter.servicingOrganizationWithoutSectionFilter?.length > 0) {
    // Runs for MPF Owners and MPF Leadership
    userAssignComponent = findUserAssignedComponentWithOrg(
      filter.servicingOrganizationWithoutSectionFilter,
      metadataContext
    )
    userServicingOrganization = [ALL_SELECT_OPTION_STRING]
  } else {
    // Runs for Section level users
    userAssignComponent = findUserAssignedComponentWithOrg(
      filter.servicingOrganizationFilter,
      metadataContext
    )
  }

  if (
    filter.assignedComponentCodeFilter?.length > 0 &&
    filter.majcomCodeFilter?.length === 0 &&
    filter.servicingOrganizationFilter?.length === 0 &&
    filter.servicingOrganizationWithoutSectionFilter?.length === 0
  ) {
    userMAJCOM = []
  } else if (
    filter.assignedComponentCodeFilter?.length === 0 &&
    filter.majcomCodeFilter?.length === 0 &&
    filter.servicingOrganizationFilter?.length === 0 &&
    filter.servicingOrganizationWithoutSectionFilter?.length > 0
  ) {
    userMAJCOM = findMAJCOM(filter.servicingOrganizationWithoutSectionFilter, metadataContext)
  } else if (
    filter.assignedComponentCodeFilter?.length === 0 &&
    filter.majcomCodeFilter?.length > 0
  ) {
    userMAJCOM = findMAJCOMWithMAJCOMCode(filter.majcomCodeFilter, metadataContext)
  } else {
    userMAJCOM = findMAJCOM(filter.servicingOrganizationFilter, metadataContext)
  }

  if (roleContext.initialInquiryAndDueoutFilter.sectionCodeFilter.length > 0) {
    userSections = findUserSection(
      roleContext.initialInquiryAndDueoutFilter.sectionCodeFilter,
      metadataContext
    )
  } else {
    userSections = metadataContext.sectionOptions
  }

  useEffect(() => {
    if (refresh || isInitialLoad.current) {
      // fetchCalendarData()
      isInitialLoad.current = false
      setRefresh(false)
    }
  }, [refresh])

  const addCalendarEventHandler = () => {
    setShowEventForm(true)
    setEventRRule(undefined)
    setEditEvent(null)
    setIsEdit(false)
    setRefresh(!refresh)
  }

  const getRefresh = async () => {
    setRefresh(true)
    await fetchCalendarData()
  }

  const refreshAfterSave = () => {
    setShowEventForm(false)
  }

  const hideModalHandler = () => {
    setShowEventForm(false)
  }

  const onDelete = () => {
    setShowAlert(true)
  }

  const deleteCalendarEvent = async () => {
    try {
      // confirm('Are you sure you want to delete this event?')
      const list = await mpfRListsHttp().getList('CalendarEventsList')
      const data = await list.deleteItem(editEvent?.id, editEvent?.etag)
      refreshAfterSave()
      getRefresh()
    } catch (e) {
      console.error('Failed to delete: ', e)
    }
  }

  const onClickAlert = async (button: string) => {
    if (button === 'OK') {
      setShowAlert(false)
      await deleteCalendarEvent()
    } else {
      setShowAlert(false)
    }
  }

  return (
    <>
      {showAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={DELETE_MESSAGE}
          onClick={onClickAlert}
          yes='OK'
        />
      )}
      <SettingsHeader
        extras={
          <div className='d-flex align-items-center flex-wrap settingsfilters'>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-200 min-w-sm-200  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41'
                id='AssignComponent'
                label='Assigned Component'
                name='Assigned Component'
                onChange={onAssignedComponentChange}
                options={assignedComponentOptions}
                value={inputValues.AssignedComponentCode}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41'
                id='ServicingMAJCOM'
                label='Servicing MAJCOM'
                name='Servicing MAJCOM'
                onChange={onMajcomChange}
                options={majcomOptions}
                value={inputValues.ServicingMAJCOMCode}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41'
                id='Section'
                label='Section'
                name='Section'
                onChange={onSectionChange}
                options={sectionOptions}
                value={inputValues.SectionCode}
              />
            </div>
            <div className='dividerdashed vertical mx-1 mx-lg-2 d-none d-md-block'></div>
            <div className='ms-2 ms-sm-auto my-sm-2'>
              <Buttons
                aria-label='Add Event'
                className='btn-sm font-0 font-xl-13 btn-primary ms-auto whitetext text-nowrap border-radius poppins-bold settingsaddbtn'
                icon='icon-add me-xl-1 font-11'
                label='ADD EVENT'
                onClick={addCalendarEventHandler}
              />
            </div>
          </div>
        }
        name='Calendar'
      />

      <Modal
        className='modalpopup border-radius2'
        isOpen={showEventForm}
        toggle={addCalendarEventHandler}
        wrapClassName='modalpopupmain'
      >
        <ModalBody>
          <AddEventForm
            closeAfterSubmit={refreshAfterSave}
            editEvent={editEvent}
            eventRRule={eventRRule}
            isEdit={isEdit}
            onClose={hideModalHandler}
            onDelete={onDelete}
            sendRefresh={getRefresh}
            setShowAlert={setShowAlert}
            userAssignComponent={userAssignComponent}
            userMAJCOM={userMAJCOM}
            userSections={sectionOptions}
            userServicingOrganization={userServicingOrganization}
          />
        </ModalBody>
      </Modal>
      <div className='my-2' ref={calendarEl}></div>
    </>
  )
}

export default SettingsCalendar
